import Box from "@mui/material/Box";
import type { ReactNode } from "react";

/** Long free text (a posting's or notice's description), scrolling past 600px. */
export default function DescriptionBlock({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: "action.hover",
        borderRadius: 1,
        overflow: "auto",
        maxHeight: 600,
        fontSize: "0.875rem",
        whiteSpace: "pre-wrap",
      }}
    >
      {children}
    </Box>
  );
}
